import { render } from "./Salon.vue?vue&type=template&id=62ce475c"
import script from "./Salon.vue?vue&type=script&lang=js"
export * from "./Salon.vue?vue&type=script&lang=js"
script.render = render

export default script